import React, { Component } from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import { Link } from 'react-router-dom';

import { formatDate } from '../../utils/functions';
import { ElementLink } from '../../components';

export class OfferCellView extends Component {
  render() {
    const { offer, style, trRef, isFromBrand } = this.props;
    const hideBrand = this.props.hideBrand || false;
    const showBrand = !hideBrand;
    const navTo = {
      pathname: `/offers/${offer.id}/edit`,
      state: { offer, isFromBrand },
    };

    function storeName() {
      return offer.store ? offer.store.name : '';
    }

    return (
      <tr style={style} ref={trRef}>
        {showBrand && (
          <ElementLink element="td" to={navTo} className="offer-cell">
            {storeName()}
          </ElementLink>
        )}
        <ElementLink element="td" to={navTo} className="offer-cell">
          {offer.title}
        </ElementLink>
        <ElementLink element="td" to={navTo} className="offer-cell">
          {formatDate(offer.startDate)}
        </ElementLink>
        <ElementLink element="td" to={navTo} className="offer-cell">
          {formatDate(offer.endDate)}
        </ElementLink>
        {showBrand && (
          <td id={offer.id} className="offer-cell-duplicate">
            <div>
              <Link
                to={{
                  pathname: '/offers/new',
                  state: { offer, isFromBrand },
                }}
                className="button"
              >
                Duplicate Offer
              </Link>
            </div>
          </td>
        )}
      </tr>
    );
  }
}

export default createFragmentContainer(OfferCellView, {
  offer: graphql`
    fragment OfferCell_offer on Offer {
      id
      title
      description
      store {
        name
        id
      }
      imageUrl
      startDate
      endDate
      isFlash
      isLatest
      isPromoted
      isRedeemable
      isCheckIn
      redemptionCode
      finePrint
      isTop
      shareableUrl
      appUrl
    }
  `,
});
